
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/model';
import store from '@/store';
import { ClubSubscriptionClient } from '@/services/Services';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class clubSubscriptionBox extends Vue {

    @Prop() userIdentifier: string;


}
